import * as React from "react";
import type { SVGProps } from "react";
const SvgIcShipment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#040747"
      fillRule="evenodd"
      d="m2.786 12.63.517-.299c.714-.412 1.29-.626 1.796-.715a3.6 3.6 0 0 1 1.247.005l.145.023c.259.04.436.068.648.052.229-.017.527-.092.97-.348l5.373-3.102c1.78-1.028 3.378-.946 4.64-.378 1.228.553 2.097 1.545 2.532 2.3l.299.517-14.467 8.352zm1.643.457 2.494 4.32L19.28 10.27c-.383-.484-.947-.998-1.65-1.314-.916-.413-2.108-.51-3.552.323l-5.373 3.102c-.565.326-1.035.471-1.476.505-.363.027-.69-.025-.946-.067l-.117-.018a2.5 2.5 0 0 0-.86-.01c-.231.04-.515.126-.878.296m8.127-.241-2.687 1.551-.597-1.034 2.687-1.551z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIcShipment;
